import React from 'react';
import { Button } from 'reactstrap'
import image404 from 'img/404.png';
import './404style.scss'
import {useHistory} from 'react-router-dom';
import {connect} from 'react-redux';

function Page404(props) {
    let history = useHistory();

    const redirectToHomepage = () => {
        if(props.auth.isAuthenticated) {
            history.push('/home');
        } else {
            history.push('/');
        }
    }

    return (
        <div className="d-flex w-100 align-items-center">
            <div className="container-404">
                <div className="left-side">
                    <h3 className="left-side-header">
                        Oops, nothing here...
                    </h3>
                    <p className="left-side-text">
                        The page you are looking for was not found.
                    </p>
                    <Button
                        onClick={redirectToHomepage} 
                        type="button" 
                        className="btn btn-danger"
                    >
                        Return to homepage
                    </Button>
                </div>
                <div className="right-side">
                    <img style={{ width: '100%', height: '100%' }} src={image404} alt="gzk about us"/>
                </div>
            </div>
        </div>
    );
}


const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(Page404);
/*<div style={{ display: 'flex', justifyContent: 'center', }}>
    <Link style={{ textDecoration: 'underline' }} to="/main/globe">
        <img
            src={logo}
            alt="Ozmosys"
            className="img-fluid"
            style={{ maxWidth: 200, marginTop: -140, }}
        />
    </Link>
</div>
<div className="d-flex justify-content-center">
    <h1 className=" display-3 mr-4">404</h1>
    <div>
        <h4 className="pt-3">Oops! You're lost.</h4>
        <p className="text-muted ">The page you are looking for was not found.</p>
    </div>
</div>
<div
    style={{
        fontSize: '20px',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    }}
>
    <Link style={{ textDecoration: 'underline' }} to="/main/globe">
        Return to homepage
    </Link>
    <span style={{ margin: '0 5px' }}>|</span>
    <a
        style={{ color: '#536c79', }}
        href="mailto:support@ozmosys.com"
    >
        <i
            style={{ color: '#70818a', }}
            className=" mr-2 fa fa-envelope"
        />
        Contact Us
    </a>
</div>*/